import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

// const adminAdaptor = createEntityAdapter({
//     selectId: (entity) => entity.community_admin_id,
// })

// const initialAdmin = adminAdaptor.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getBwgsurvey: builder.query({
            query: () => '/b2g/eco-admin/survey/bulk-waste-generator',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                console.log("responseData?.data",responseData);
                
                return responseData?.data
                // return adminAdaptor.setAll(initialAdmin, responseData?.data)
            },
            // providesTags: (result, error, arg) => {
            //     console.log("result",result?.entities?.undefined);

            //     if (error || !result?.entities?.undefined?.ids) {
            //         return [{ type: 'B2gAdmin', id: 'List' }, []];
            //     } else {
            //         return result?.entities?.undefined?.map(id => ({ type: 'B2gAdmin', id }));
            //     }
            // }
        }),
    })
})

export const {
    useGetBwgsurveyQuery,
} = extendedApiSlice
